var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarSingle = function SvgStarSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#starSingle_svg__a)",
    d: "m14.55 8.494 3.242 1.167c.32.112.32.575 0 .687l-3.243 1.166a5.1 5.1 0 0 0-3.035 3.035l-1.166 3.243c-.112.32-.575.32-.687 0L8.494 14.55a5.1 5.1 0 0 0-3.035-3.035l-3.243-1.166c-.32-.112-.32-.575 0-.687l3.243-1.167A5.1 5.1 0 0 0 8.494 5.46l1.167-3.243c.112-.32.575-.32.687 0l1.166 3.243a5.1 5.1 0 0 0 3.035 3.035"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "starSingle_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(7.119 -63.355 4.99)scale(18.4202 35.8852)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369,
    stopColor: "#FFCB42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.704,
    stopColor: "#FFECBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E79A26"
  })))));
};
export default SvgStarSingle;